const isValidEmailFormat = (s: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)

// A ``+`` in an email arrives URL-decoded as a space, so restore it before validating.
const normalizeEmailFromUrl = (s: string): string => s.trim().replace(/\s/g, '+')

/** The ``email`` query parameter when it is a well-formed address, else ``''``. */
export function getEmailFromSearchParams(searchParams: URLSearchParams | string | undefined): string {
  const params =
    typeof searchParams === 'string' || searchParams === undefined
      ? new URLSearchParams(searchParams ?? '')
      : searchParams
  const fromEmail = normalizeEmailFromUrl(params.get('email') ?? '')
  return fromEmail && isValidEmailFormat(fromEmail) ? fromEmail : ''
}
